import { cn } from "@/lib/utils";

type AgentStatus = "active" | "running" | "idle" | "paused" | "error" | string;

interface AgentStatusPillProps {
  status: AgentStatus;
  mini?: boolean;
  className?: string;
}

// Aurora status colors (spec): Online/Working #10B981 (Working pulses),
// Idle text3, Paused warn #E79D13, Error danger #E5484D.
const MAP: Record<string, { label: string; color: string; pulse?: boolean }> = {
  active: { label: "Online", color: "#10B981" },
  running: { label: "Working", color: "#10B981", pulse: true },
  idle: { label: "Idle", color: "var(--mg-text3, #8E94A3)" },
  paused: { label: "Paused", color: "#E79D13" },
  error: { label: "Error", color: "#E5484D" },
};

export function AgentStatusPill({ status, mini, className }: AgentStatusPillProps) {
  const s = MAP[status] ?? MAP.idle;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 font-medium",
        mini ? "text-[10px]" : "text-[11px]",
        className,
      )}
      style={{ color: s.color }}
    >
      <span
        className={cn("inline-block rounded-full", s.pulse && "mg-status-pulse")}
        style={{ width: 6, height: 6, background: s.color }}
      />
      {s.label}
    </span>
  );
}
